module.exports = __webpack_public_path__ + "static/media/ep_naturalblack.23e2b6cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/otherimages/ep_naturalblack.png
// module id = 333
// module chunks = 0